const delayPromise = async (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export const retry = async <T>(
  promiseFn: (attempt: number) => Promise<T>,
  attempts: number,
  waitInMs: number,
): Promise<T> => {
  const tryFn = async (attempt: number): Promise<T> => {
    try {
      return await promiseFn(attempt);
    } catch (error) {
      if (attempt >= attempts) {
        throw error;
      }
      await delayPromise(waitInMs);
      return tryFn(attempt + 1);
    }
  };

  return tryFn(1);
};
